export enum EmptyStateLevels {
  Floor = 'floor',
  Location = 'location',
}
